import { postApi } from '../../utils/api'

export function getJWT() {
  return postApi({ endpoint: '/api/jwt/token/for-authenticated/' })
}

export function refreshJWT(data) {
  return postApi({ data, endpoint: '/api/jwt/token/refresh/' })
}
